module.exports = __webpack_public_path__ + "img/no-data-ticket.23b10fb8.png";